/* eslint-disable no-unused-expressions */
/* eslint-disable no-case-declarations */
import Scene from 'scenejs';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { forEachCanvasObject } from '@/components/Canvas/utils/groupHelpers';

const ElementAnimationMixin = {
  data() {
    return {
      scene:              new Scene(),
      scenes:             new Scene(),
      multipleScenesJson: {},
      animations:         {},
      selector:           null,
      selectedObject:     null,
      typingSelector:     '',
      typingInProgress:   false,
      previewRestoreList: [],
      _animationBatch:    { sceneItems: {}, restore: [] },
      _animationRestarting: false,
    };
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.stopScene);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.stopScene);
  },
  beforeDestroy() {
    EventBus.$off(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.stopScene);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.stopScene);
  },
  methods: {
    buildBurstKeyframes(onEnter, onExit, hold = 0) {
      const popIn     = 0.18;
      const popSettle = 0.32;
      const popPeak   = 0.14;
      const popOut    = 0.36;
      const origin    = '50% 50%';
      const frames    = {};
      if (onEnter) {
        frames[0]         = { opacity: 0, display: 'inline-block', transformOrigin: origin, transform: { scale: '0.1, 0.1' } };
        frames[popIn]     = { opacity: 1, display: 'inline-block', transformOrigin: origin, transform: { scale: '1.35, 1.35' } };
        frames[popSettle] = { opacity: 1, display: 'inline-block', transformOrigin: origin, transform: { scale: '1, 1' } };
      } else {
        frames[0] = { opacity: 1, display: 'inline-block', transformOrigin: origin, transform: { scale: '1, 1' } };
      }
      if (onExit) {
        const exitAt = onEnter ? hold : 0;
        if (onEnter) {
          frames[exitAt] = { opacity: 1, display: 'inline-block', transformOrigin: origin, transform: { scale: '1, 1' } };
        }
        frames[exitAt + popPeak] = { opacity: 1, display: 'inline-block', transformOrigin: origin, transform: { scale: '1.35, 1.35' } };
        frames[exitAt + popOut]  = { opacity: 0, display: 'inline-block', transformOrigin: origin, transform: { scale: '0.1, 0.1' } };
      }
      return frames;
    },
    buildTypewriterKeyframes(onEnter, onExit, hold = 0) {
      const appear = 0.08;
      const frames = {};
      if (onEnter) {
        frames[0]      = { visibility: 'hidden' };
        frames[appear] = { visibility: 'visible' };
      } else {
        frames[0] = { visibility: 'visible' };
      }
      if (onExit) {
        const exitAt = onEnter ? hold : 0;
        if (onEnter) {
          frames[exitAt] = { visibility: 'visible' };
        }
        frames[exitAt + appear] = { visibility: 'hidden' };
      }
      return frames;
    },
    productHasVideoOrElementAnimation() {
      const { product } = this;
      if (!product || !product.pages) {
        return false;
      }
      let found = false;
      product.pages.forEach((page) => {
        if (!page.objectList) {
          return;
        }
        forEachCanvasObject(page.objectList, (object) => {
          if (object.type === 'video' || (object.animation && String(object.animation.style || '').trim() !== '')) {
            found = true;
          }
        });
      });
      return found;
    },
    animateElement({
                     speed, style, onEnter = true, onExit = false, duration, distance, objects,
                   }) {
      const objectsToAnimate = (objects && objects.length)
          ? objects
          : (this.activeObject ? [this.activeObject] : []);
      if (!objectsToAnimate.length) {
        return;
      }

      this._animationRestarting = true;
      this.scene.end();
      this.restorePreviewMarkup();
      this._animationRestarting = false;
      this._animationBatch = { sceneItems: {}, restore: [] };
      objectsToAnimate.forEach((activeObject) => {
        this.collectElementAnimation(activeObject, {
          speed, style, onEnter, onExit, duration, distance,
        });
      });

      const { sceneItems } = this._animationBatch;
      this.previewRestoreList = this._animationBatch.restore;
      if (!Object.keys(sceneItems).length) {
        return;
      }

      this.selectedObject = this.activeObject || objectsToAnimate[0];
      this.scene = new Scene(sceneItems, {
        easing:   'ease-in-out',
        selector: true,
      });
      this.scene.play();

      const self = this;
      setTimeout(() => {
        self.scene.on('ended', this.sceneEnded);
      }, 50);
    },
    collectElementAnimation(activeObject, {
      speed, style, onEnter = true, onExit = false, duration, distance,
    }) {
      if (!activeObject || !activeObject.Id) {
        return;
      }
      const startTime        = 0.0;
      let transitionDuration = 0.0;
      transitionDuration     = this.getTransitionTime(speed, duration);
      const sx = Number(activeObject.scaleX) || 1;
      const sy = Number(activeObject.scaleY) || 1;
      const usesObjectScale = ['text', 'table'].includes(activeObject.type);
      const transformOrigin = this.getAnimationTransformOrigin(activeObject.type);

      this.selectedObject    = activeObject;
      let selector           = `.canvas-section .canvas-non-play-all [id='${activeObject.Id}']`;
      let objectOpacity      = activeObject.effects ? activeObject.effects.transparency.value / 100 : 1;
      if (activeObject.type === 'shape') {
        objectOpacity = activeObject.Alpha / 100;
      }

      this.tempSelector               = selector;
      let numOfCharacter              = 0;
      let exitDistance                = 0;
      let animationDurationPercentage = null;
      const previewEl                 = document.querySelector(selector);
      if (!previewEl) {
        return;
      }
      const originalStyle = previewEl.getAttribute('style');
      const markup        = (style === 'burst' || style === 'typewriter')
          ? this.snapshotAnimationMarkup(previewEl)
          : null;
      this.tempHtml       = originalStyle;
      distance            = parseFloat(distance) + 20;
      let animation       = {};
      switch (style) {
        case 'panleft':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          }
          break;
        case 'panright':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateX: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          }
          break;
        case 'pantop':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          }
          break;
        case 'panbottom':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `-${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: '0%',
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration] = {
                  transform: {
                    scale:      usesObjectScale ? `${sx},${sy}` : undefined,
                    translateY: `${distance}%`,
                    rotate:     `${activeObject.RotateDegree}deg`,
                  },
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          }
          break;
        case 'fade':
          if (onEnter && !onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
                animation[startTime + 0.00001] = {
                  opacity: 0,
                },
                animation[transitionDuration] = {
                  opacity: objectOpacity,
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
                animation[startTime + 0.1] = {
                  opacity: objectOpacity,
                },
                animation[transitionDuration] = {
                  opacity: 0,
                },
                animation[transitionDuration + 0.0001] = {
                  opacity: objectOpacity,
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
                animation[startTime + 0.00001] = {
                  opacity: 0,
                },
                animation[transitionDuration] = {
                  opacity: objectOpacity,
                },
                animation[transitionDuration + transitionDuration] = {
                  opacity: 0,
                },
                animation[transitionDuration + transitionDuration + 0.0004] = {
                  opacity: objectOpacity,
                };
          }
          break;
        case 'zoomin':
          if (onEnter && !onExit) {
            animation[startTime] = this.zoomStompKeyframe(
                activeObject,
                0.7,
                { opacity: 0, transition: 'none' },
            );
            animation[transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1,
                { opacity: objectOpacity },
            );
          } else if (!onEnter && onExit) {
            animation[startTime] = this.zoomStompKeyframe(
                activeObject,
                1,
                { opacity: objectOpacity, transition: 'none' },
            );
            animation[transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1.3,
                { opacity: 0 },
            );
          } else if (onEnter && onExit) {
            animation[startTime] = this.zoomStompKeyframe(
                activeObject,
                0.7,
                { opacity: 0, transition: 'none' },
            );
            animation[transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1,
                { opacity: objectOpacity },
            );
            animation[transitionDuration + transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1.3,
                { opacity: 0 },
            );
          }
          break;
        case 'zoomout':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transformOrigin,
              transform:       {
                scale: '100%',
              },
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale: '100%',
                  },
                },
                animation[transitionDuration] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-0.70' : '0.70'},${activeObject.IsVFlipped === true ? '-0.70' : '0.70'}` : '70%',
                  },
                };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transformOrigin,
              transform:       {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            },
                animation[startTime + 0.1] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                  },
                },
                animation[transitionDuration] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                  },
                };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transformOrigin,
              transform:       {
                scale: '100%',
              },
            },
                animation[startTime + 0.00001] = {
                  transform: {
                    scale: '100%',
                  },
                },
                animation[transitionDuration] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-0.70' : '0.70'},${activeObject.IsVFlipped === true ? '-0.70' : '0.70'}` : '70%',
                  },
                },
                animation[transitionDuration + 0.0001] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                  },
                },
                animation[transitionDuration + 1] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                  },
                },
                animation[transitionDuration + transitionDuration] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                  },
                },
                animation[transitionDuration + transitionDuration + 0.0001] = {
                  transform: {
                    scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                  },
                };
          }
          break;
        case 'burst': {
          this.typingSelector   = selector;
          this.typingInProgress = true;
          const wrapRoot        = previewEl.querySelector('.focus-text-div') || previewEl;
          this.wrapBurstText(wrapRoot);
          break;
        }
        case 'typewriter': {
          this.typingSelector   = selector;
          const typingHost      = (markup && markup.host) || previewEl;
          const originalHTML    = typingHost.innerHTML;
          this.typingInProgress = true;
          let newHTML           = '';
          let tagStarted        = false;
          let ampersendStarted  = false;
          for (let i = 0; i < originalHTML.length; i++) {
            if (originalHTML[i] === '<' && !ampersendStarted) {
              tagStarted = true;
            }
            if (originalHTML[i] === '&' && !tagStarted) {
              ampersendStarted = true;
              newHTML          = `${newHTML}<span class="animationItem" >`;
            }
            if (!tagStarted && !ampersendStarted) {
              newHTML = `${newHTML}<span class="animationItem" >${originalHTML[i]}</span>`;
            } else {
              newHTML += originalHTML[i];
            }
            if (originalHTML[i] === '>' && tagStarted) {
              tagStarted = false;
            }
            if (originalHTML[i] === ';' && ampersendStarted) {
              ampersendStarted = false;
              newHTML          = `${newHTML}</span>`;
            }
          }
          typingHost.innerHTML = newHTML;
          break;
        }
        case 'stomp':
          if (onEnter && !onExit) {
            animation[startTime] = this.zoomStompKeyframe(
                activeObject,
                10,
                { transition: 'none' },
            );
            animation[transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1,
            );
          } else if (!onEnter && onExit) {
            animation[startTime]          = {
              opacity:    objectOpacity,
              transition: 'none',
            };
            animation[startTime + 0.0001] = {
              opacity: 0,
            };
            animation[transitionDuration] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = this.zoomStompKeyframe(
                activeObject,
                10,
                { transition: 'none' },
            );
            animation[transitionDuration] = this.zoomStompKeyframe(
                activeObject,
                1,
                { opacity: objectOpacity },
            );
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'spreadout':
          animation = {
            0: {
              letterSpacing: 'inherit',
              width:         '100% !important',
              transform:     {
                translateX: '0%',
              },
            },
            0.00001: {
              width:         '100%  !important',
              letterSpacing: '0px',
              transform:     {
                translateX: '0%',
              },
            },
            5: {
              width:         '200% !important',
              letterSpacing: '5px',
              transform:     {
                translateX: '-25%',
              },
            },
          };
          break;
        case 'spreadin':
          animation = {
            0: {
              letterSpacing: 'inherit',
              width:         '100% !important',
              transform:     {
                translateX: '0%',
              },
            },
            0.00001: {
              width:         '200% !important',
              letterSpacing: '5px',
              transform:     {
                translateX: '-25%',
              },
            },
            4.9999: {
              width:         '100%  !important',
              letterSpacing: '0px',
              transform:     {
                translateX: '0%',
              },
            },
            5: {
              width:         '100%  !important',
              letterSpacing: 'inherit',
              transform:     {
                translateX: '0%',
              },
            },
          };
          break;
        case 'photoZomEnterIn':
          console.log('Animating photo zoom');
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: 1,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: 1,
            };
          }
          break;
        case 'photoZomEnterOut':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: 1,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType === 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                scale:  activeObject.ImageType === 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: 1,
            };
          }
          break;
        case 'photoRiseTop':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseBottom':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseLeft':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseRight':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        default:
          return;
      }

      const restoreSelector = `.canvas-section .canvas-non-play-all [id='${activeObject.Id}']`;
      const restoreItem = {
        selector:     restoreSelector,
        originalStyle,
        markup,
      };
      if (selector !== restoreSelector) {
        const animatedEl = document.querySelector(selector);
        restoreItem.animatedSelector = selector;
        restoreItem.animatedStyle    = animatedEl ? animatedEl.getAttribute('style') : null;
      }
      if (!this._animationBatch) {
        this._animationBatch = { sceneItems: {}, restore: [] };
      }
      this._animationBatch.restore.push(restoreItem);

      if (style == 'burst' || style == 'typewriter') {
        const letterCount = document.querySelectorAll(`${selector} .animationItem`).length;
        const isBurst     = style === 'burst';
        const timing      = this.getCharacterDelay(speed, duration, letterCount, {
          onEnter,
          onExit,
          enterDur: isBurst ? 0.32 : 0.08,
          exitDur:  isBurst ? 0.36 : 0.08,
        });
        animation = isBurst
            ? this.buildBurstKeyframes(onEnter, onExit, timing.hold)
            : this.buildTypewriterKeyframes(onEnter, onExit, timing.hold);
        this._animationBatch.sceneItems[`${selector} .animationItem`] = i => ({
          ...animation,
          options: {
            delay: i * timing.letterDelay,
          },
        });
      } else {
        this._animationBatch.sceneItems[selector] = animation;
      }
    },
    restorePreviewMarkup() {
      (this.previewRestoreList || []).forEach((item) => {
        const el = document.querySelector(item.selector);
        if (!el) {
          return;
        }
        if (item.markup) {
          this.restoreAnimationMarkup(item.markup);
        }
        if (item.originalStyle != null) {
          el.setAttribute('style', item.originalStyle);
        }
        if (item.animatedSelector && item.animatedStyle != null) {
          const animatedEl = document.querySelector(item.animatedSelector);
          if (animatedEl) {
            animatedEl.setAttribute('style', item.animatedStyle);
          }
        }
      });
      this.previewRestoreList = [];
      this.typingSelector = '';
      this.tempHtml = null;
    },
    sceneEnded() {
      if (this._animationRestarting) {
        return;
      }
      this.scene.setTime(0);
      this.restorePreviewMarkup();
      const isVideoModeOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];
      if (!isVideoModeOn && this.productHasVideoOrElementAnimation()) {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      }
      if (this.selectedObject && this.selectedObject.type == 'shape') {
        this.$store.commit('activeProduct/setIsAnimationInProgress', false);
      }
      EventBus.$emit(ApplicationEventTypes.Canvas.RESTORE_BOUNDING_BOX);
    },
    snapshotAnimationMarkup(el) {
      const wrapper = el.querySelector('.focus-text-div');
      const host    = (wrapper && wrapper.firstElementChild) || wrapper || el;
      return {
        host,
        html:         host.innerHTML,
        wrapper,
        wrapperStyle: wrapper ? wrapper.getAttribute('style') : null,
      };
    },
    restoreAnimationMarkup({ host, html, wrapper, wrapperStyle }) {
      if (host && host.isConnected) {
        host.innerHTML = html;
      }
      if (wrapper && wrapper.isConnected) {
        if (wrapperStyle == null) {
          wrapper.removeAttribute('style');
        } else {
          wrapper.setAttribute('style', wrapperStyle);
        }
      }
    },
    wrapBurstText(root) {
      if (!root) {
        return;
      }
      const isCurve = (root.closest && root.closest('.curve-text-div'))
          || (() => {
            const span = root.querySelector('span');
            return !!(span && (span.style.position === 'absolute'
                || window.getComputedStyle(span).position === 'absolute'));
          })();
      if (isCurve && root.querySelector('span')) {
        this.wrapBurstOnCurveLetters(root);
        if (root.querySelector('.animationItem')) {
          return;
        }
      }
      const holdWidth  = root.offsetWidth;
      const holdHeight = root.offsetHeight;
      const marks      = this.measureBurstCharacterMarks(root);
      this.spanEachCharacter(root);
      const items = root.querySelectorAll('.animationItem');
      if (!marks.length || items.length !== marks.length) {
        return;
      }
      this.applyBurstGradientToLetters(root, items, marks, holdWidth, holdHeight);
      const hasSpread = marks.some((m, i) => i > 0 && (Math.abs(m.left - marks[0].left) > 0.5 || Math.abs(m.top - marks[0].top) > 0.5));
      if (!hasSpread) {
        return;
      }
      const laidOut = window.getComputedStyle(root);
      if (laidOut.position === 'static') {
        root.style.position = 'relative';
      }
      const padX = (parseFloat(laidOut.paddingLeft) || 0) + (parseFloat(laidOut.paddingRight) || 0);
      const padY = (parseFloat(laidOut.paddingTop) || 0) + (parseFloat(laidOut.paddingBottom) || 0);
      const borderBox = laidOut.boxSizing === 'border-box';
      root.style.width     = `${borderBox ? holdWidth : Math.max(0, holdWidth - padX)}px`;
      root.style.minWidth  = root.style.width;
      root.style.minHeight = `${borderBox ? holdHeight : Math.max(0, holdHeight - padY)}px`;
      items.forEach((item, i) => {
        item.style.position        = 'absolute';
        item.style.left            = `${marks[i].left}px`;
        item.style.top             = `${marks[i].top}px`;
        if (!item.style.padding) {
          item.style.margin = '0';
        }
        item.style.display         = 'inline-block';
        item.style.transformOrigin = '50% 50%';
      });
    },
    applyBurstGradientToLetters(root, items, marks, width, height) {
      const rootStyle = window.getComputedStyle(root);
      const image     = rootStyle.backgroundImage;
      if (rootStyle.webkitBackgroundClip !== 'text' || !image || image === 'none') {
        return;
      }
      const bleedY = parseFloat(rootStyle.paddingTop) || 0;
      const bleedX = parseFloat(rootStyle.paddingLeft) || 0;
      root.style.backgroundImage = 'none';
      items.forEach((item, i) => {
        item.style.boxSizing            = 'content-box';
        item.style.padding              = `${bleedY}px ${bleedX}px`;
        item.style.margin               = `${-bleedY}px ${-bleedX}px`;
        item.style.backgroundImage      = image;
        item.style.backgroundOrigin     = 'padding-box';
        item.style.backgroundSize       = `${width}px ${height}px`;
        item.style.backgroundRepeat     = 'no-repeat';
        item.style.backgroundPosition   = `${bleedX - marks[i].left}px ${bleedY - marks[i].top}px`;
        item.style.webkitBackgroundClip = 'text';
        item.style.backgroundClip       = 'text';
        item.style.webkitTextFillColor  = 'transparent';
      });
    },
    wrapBurstOnCurveLetters(root) {
      if (root.querySelector('.animationItem')) {
        return;
      }
      Array.from(root.querySelectorAll('span')).forEach((letter) => {
        if (letter.classList.contains('animationItem') || letter.querySelector('.animationItem')) {
          return;
        }
        const pos = letter.style.position || window.getComputedStyle(letter).position;
        if (pos !== 'absolute') {
          return;
        }
        const inner = document.createElement('span');
        inner.className             = 'animationItem';
        inner.style.display         = 'inline-block';
        inner.style.transformOrigin = '50% 50%';
        inner.style.color           = 'inherit';
        while (letter.firstChild) {
          inner.appendChild(letter.firstChild);
        }
        letter.appendChild(inner);
      });
    },
    measureBurstCharacterMarks(root) {
      const rootRect = root.getBoundingClientRect();
      const sx       = rootRect.width / (root.offsetWidth || rootRect.width || 1) || 1;
      const sy       = rootRect.height / (root.offsetHeight || rootRect.height || 1) || 1;
      const marks    = [];
      const range    = document.createRange();
      const walk     = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          if (!text || /^\s+$/.test(text)) {
            return;
          }
          let offset = 0;
          [...text].forEach((c) => {
            const len = c.length;
            range.setStart(node, offset);
            range.setEnd(node, offset + len);
            const r = range.getBoundingClientRect();
            marks.push({
              left: (r.left - rootRect.left) / sx,
              top:  (r.top - rootRect.top) / sy,
            });
            offset += len;
          });
          return;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          Array.from(node.childNodes).forEach(walk);
        }
      };
      walk(root);
      return marks;
    },
    spanEachCharacter(el) {
      if (!el) {
        return;
      }
      if (el.nodeType == Node.TEXT_NODE) {
        const text = el.textContent;
        if (!text || /^\s+$/.test(text)) {
          return;
        }
        let html = '';
        [...text].forEach((c) => {
          html += `<span class="animationItem" style="display:inline-block;transform-origin:50% 50%;">${c}</span>`;
        });
        const node = document.createElement('span');
        el.parentNode.insertBefore(node, el);
        el.parentNode.removeChild(el);
        node.outerHTML = html;
      } else if (el.nodeType === Node.ELEMENT_NODE) {
        Array.from(el.childNodes).forEach((child) => {
          this.spanEachCharacter(child);
        });
      }
    },
    getAnimationTransformOrigin(type) {
      return (type === 'table' || type === 'image') ? 'top left' : 'center center';
    },
    zoomStompKeyframe(obj, scaleVal, extras = {}) {
      return {
        transformOrigin: this.getAnimationTransformOrigin(obj.type),
        transform:       this.getZoomStompTransform(obj, scaleVal),
        ...extras,
      };
    },
    getZoomStompTransform(obj, scaleMultiplier) {
      const restSx = Number(obj.scaleX) || 1;
      const restSy = Number(obj.scaleY) || 1;
      const m      = Number(scaleMultiplier);
      const animSx = restSx * m;
      const animSy = restSy * m;
      const w      = Number(obj.Width) || 0;
      const h      = Number(obj.Height) || 0;
      const shift = obj.type === 'table' || obj.type === 'image';
      const tx    = shift ? (w * (restSx - animSx)) / 2 : 0;
      const ty    = shift ? (h * (restSy - animSy)) / 2 : 0;
      // translateX/Y first so Scene.js emits them before scale (centered slam).
      return {
        translateX: `${tx}px`,
        translateY: `${ty}px`,
        rotate:     `${obj.RotateDegree || 0}deg`,
        scale:      `${animSx}, ${animSy}`,
      };
    },
    stopScene() {
      this._animationRestarting = true;
      this.scene.end();
      this._animationRestarting = false;
      this.restorePreviewMarkup();
    },
    pageTransitionEnded() {
      this.scene.setTime(0);
    },
    getTransitionTime(objectSpeed, objectDuration) {
      const speed    = parseFloat(objectSpeed);
      const duration = parseFloat(objectDuration);
      if (!duration || Number.isNaN(duration)) {
        return 0.8;
      }
      let percentage = 12;
      if (Number.isNaN(speed) || speed <= 20) {
        percentage = 80;
      } else if (speed <= 40) {
        percentage = 55;
      } else if (speed <= 60) {
        percentage = 35;
      } else if (speed <= 80) {
        percentage = 20;
      } else {
        percentage = 8;
      }
      return (duration / 100) * percentage;
    },
    getTypwriterSpeed(speed, duration) {
      const objectSpeed    = parseFloat(speed);
      const objectDuration = parseFloat(duration) || 5;
      let percentage       = 20;
      if (Number.isNaN(objectSpeed) || objectSpeed <= 20) {
        percentage = 90;
      } else if (objectSpeed <= 40) {
        percentage = 65;
      } else if (objectSpeed <= 60) {
        percentage = 45;
      } else if (objectSpeed <= 80) {
        percentage = 28;
      } else {
        percentage = 12;
      }
      return (objectDuration / 100) * percentage;
    },
    getCharacterDelay(speed, duration, letterCount, opts = {}) {
      const n        = Math.max(1, letterCount);
      const onEnter  = opts.onEnter !== false;
      const onExit   = !!opts.onExit;
      const enterDur = opts.enterDur || 0.08;
      const exitDur  = opts.exitDur || 0.08;
      const pageDur  = Math.max(0.2, parseFloat(duration) || 5);
      const budget   = Math.min(pageDur, this.getTypwriterSpeed(speed, pageDur));
      let letterDelay = 0;
      let hold        = 0;

      if (n <= 1) {
        hold = onEnter && onExit ? Math.max(enterDur + 0.2, budget - exitDur) : 0;
        return { letterDelay, hold };
      }

      if (onEnter && onExit) {
        const usable = Math.max(0.05, budget - enterDur - exitDur);
        letterDelay  = usable / (2 * (n - 1));
        hold         = budget - ((n - 1) * letterDelay) - exitDur;
        const lastEnterEnd = ((n - 1) * letterDelay) + enterDur;
        if (hold < lastEnterEnd) {
          hold = lastEnterEnd;
        }
      } else {
        const animDur = onExit && !onEnter ? exitDur : enterDur;
        letterDelay   = Math.max(0, (budget - animDur) / (n - 1));
      }
      return { letterDelay, hold };
    },
  },
};

export default ElementAnimationMixin;
